import React, { forwardRef } from 'react'
import { Input } from 'antd'
import { NumericFormat } from 'react-number-format'

interface NumberInputProps {
  value?: string | number
  onChange?: (value: string) => void
  placeholder?: string
  disabled?: boolean
  className?: string
  style?: React.CSSProperties
  onBlur?: () => void
  onFocus?: () => void
  prefix?: string
  suffix?: string
  size?: 'large' | 'middle' | 'small'
  allowNegative?: boolean
  decimalScale?: number
  thousandSeparator?: string
  decimalSeparator?: string
}

const NumberInput = forwardRef<HTMLInputElement, NumberInputProps>(
  (
    {
      value,
      onChange,
      placeholder = '0.00',
      disabled = false,
      className,
      style,
      onBlur,
      onFocus,
      prefix,
      suffix,
      size = 'middle',
      allowNegative = false,
      decimalScale = 2,
      thousandSeparator = ' ',
      decimalSeparator = '.',
      ...restProps
    },
    ref,
  ) => {
    const handleValueChange = (values: {
      value: string
      floatValue?: number
    }) => {
      if (onChange) {
        onChange(values.value)
      }
    }

    return (
      <NumericFormat
        customInput={Input}
        value={value}
        onValueChange={handleValueChange}
        placeholder={placeholder}
        disabled={disabled}
        className={className}
        style={style}
        onBlur={onBlur}
        onFocus={onFocus}
        prefix={prefix}
        suffix={suffix}
        size={size}
        allowNegative={allowNegative}
        decimalScale={decimalScale}
        fixedDecimalScale={true}
        thousandSeparator={thousandSeparator}
        decimalSeparator={decimalSeparator}
        getInputRef={ref}
        {...restProps}
      />
    )
  },
)

NumberInput.displayName = 'NumberInput'

export default NumberInput
